/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetElaAssessmentSessionReportR200ResponseQuestionsInnerAssessmentQuestionsFromJSON, GetElaAssessmentSessionReportR200ResponseQuestionsInnerAssessmentQuestionsToJSON, } from './GetElaAssessmentSessionReportR200ResponseQuestionsInnerAssessmentQuestions';
/**
 * @export
 */
export const GetElaAssessmentSessionReportR200ResponseQuestionsInnerTypeEnum = {
    ArticleFiction: 'article_fiction',
    ArticleNonFiction: 'article_non_fiction',
    Grammar: 'grammar',
    Vocabulary: 'vocabulary',
    Listening: 'listening'
};
/**
 * Check if a given object implements the GetElaAssessmentSessionReportR200ResponseQuestionsInner interface.
 */
export function instanceOfGetElaAssessmentSessionReportR200ResponseQuestionsInner(value) {
    if (!('accuracy' in value) || value['accuracy'] === undefined)
        return false;
    if (!('assessmentQuestions' in value) || value['assessmentQuestions'] === undefined)
        return false;
    if (!('numAnswers' in value) || value['numAnswers'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function GetElaAssessmentSessionReportR200ResponseQuestionsInnerFromJSON(json) {
    return GetElaAssessmentSessionReportR200ResponseQuestionsInnerFromJSONTyped(json, false);
}
export function GetElaAssessmentSessionReportR200ResponseQuestionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accuracy': json['accuracy'],
        'assessmentQuestions': GetElaAssessmentSessionReportR200ResponseQuestionsInnerAssessmentQuestionsFromJSON(json['assessmentQuestions']),
        'numAnswers': json['numAnswers'],
        'type': json['type'],
    };
}
export function GetElaAssessmentSessionReportR200ResponseQuestionsInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'accuracy': value['accuracy'],
        'assessmentQuestions': GetElaAssessmentSessionReportR200ResponseQuestionsInnerAssessmentQuestionsToJSON(value['assessmentQuestions']),
        'numAnswers': value['numAnswers'],
        'type': value['type'],
    };
}
